module.exports = __webpack_public_path__ + "img/card.85d2c048.svg";